<div class="table-responsive" [class.overflow-hidden]="frontDeskInstructionsService.emptyRowService.emptyRow.length > 0">
<!-- <div class="table-responsive"> -->
    <table class="table table-striped table-hover front-desk-instructions-list-table footable">
        <thead>
            <tr>
                <th (click)="orderBy('id', $event)">ID 
                    <span *ngIf="authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('type', $event)">Type
                    <span *ngIf="authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('subject', $event)">Instructions
                    <span *ngIf="authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('startDate', $event)">Start Date
                    <span *ngIf="authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('endDate', $event)">End Date
                    <span *ngIf="authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdBy.fullName', $event)">Created By
                    <span *ngIf="authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdAt', $event)">Created On
                    <span *ngIf="authenticationService.userIsResident" class="footable-sort-indicator"></span>
                </th>
                <th>Status
                </th>
                <th>Action
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="frontDeskInstructionsService.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}">
                    <td>
                        <div class="table-mobile-left">
                            <span>ID</span>
                        </div>
                        <span>{{item.id}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Type</span>
                        </div>
                        <span *ngIf="item.type === 'entry_instruction'" >Entry Instruction</span>
                        <span *ngIf="item.type === 'vacation_instruction'" >Vacation Instruction</span>
                    </td>
                    <td class="front-desk-instructions-list-hint-td">
                        <div class="table-mobile-left">
                            <span>Instructions</span>
                        </div>
                        <span class="clickable-text mtv-primary-color " (click)="showHint($event)">{{item.subject}}</span>

                        <div class="front-desk-instructions-list-hint {{index > 7 ? 'up' : 'down'}}">
                            <pre>{{item.text || '-'}}</pre>
                        </div>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Start Date</span>
                        </div>
                        <span>{{item.startDate | mccDate}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>End Date</span>
                        </div>
                        <span>{{item.endDate | mccDate}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Created By</span>
                        </div>
                        <span>{{item.createdBy.fullName}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Created On</span>
                        </div>
                        <span>{{item.createdAt | mccDate:false:true}}</span>
                    </td>
                    <td>
                        <div class="table-mobile-left">
                            <span>Status</span>
                        </div>
                        <div class="table-mobile-right">
                                <span *ngIf="item.status === 'future'" class="text-uppercase label  label-future">Future</span>
                                <span *ngIf="item.status === 'past'" class="text-uppercase label  label-expired">Expired</span>
                                <span *ngIf="item.status === 'current'" class="text-uppercase label label-active">Active</span>
                            </div>
                    </td>
                    <td class="td-action-btn">
                    
                        <div *ngIf="authenticationService.userIsResident" class="table-mobile-left">
                            <div class="actions-buttons">
                                <button (click)="frontDeskInstructionsService.editInstruction(item)"
                                    class="btn btn-white btn-xs edit-button-dropdown no-arrow-button-width">Edit</button>
                                    <button (click)="frontDeskInstructionsService.deleteInstruction(item)"
                                    class="btn btn-white btn-xs edit-button-dropdown no-arrow-button-width">Delete</button>
                            </div>
                        </div>
                            <div class="input-group-btn btn-in-table input-group" *ngIf="authenticationService.userIsResident">
                                <button (click)="frontDeskInstructionsService.editInstruction(item)" class="btn btn-white btn-xs edit-button-dropdown same-button-width" style="width: 50px;">Edit</button>
                                <button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs" aria-expanded="false">
                                    <span class="caret"></span>
                                </button>
                                <ul class="dropdown-menu pull-right">
                                    <li (click)="frontDeskInstructionsService.deleteInstruction(item)">
                                        <a>Delete</a>
                                    </li>
                                </ul>
                            </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of frontDeskInstructionsService.emptyRowService.emptyRow" class="empty-row" style="cursor: default;">
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
        </tbody>
    </table>
    <h2 *ngIf="frontDeskInstructionsService.data?.total == 0 && !frontDeskInstructionsService.showServiceUnavailable" class="text-center">Result Not Found</h2>
    <h2 *ngIf="frontDeskInstructionsService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/front-desk-instructions/front-desk-instructions-list/front-desk-instructions-list.component.html